<div class="common-text-input__container"
  [id]="fieldTypeLogo.id">
  <div class="field-type-logo__container-box"
    [ngClass]="{'field-type-logo__container-box--favicon': type === 'favicon',
    'common-text-input__container-box--error': field.error}"
    [attr.disabled]="field.noEditable || (type === 'edit' && !canAdmin)?true:null">
    <div class="common-text-input__block-header">
      <div class="common-text-input__label">
        <span class="common-text-input__text-label">{{titleField}}</span>
        @if (field.required) {
          <span class="common-tag__mandatory-text-asterisk"
            [ngClass]="{'common-tag__mandatory-text-asterisk--disabled': field.noEditable || (type === 'edit' && !canAdmin) }">
            *
          </span>
        }
        @if (field.description) {
          <tooltip-info
            [description]="field.description"
            [field]="field">
          </tooltip-info>
        }
      </div>
      <button class="common-button__icon-sm-noborder"
        (click)="openFileInput()"
        [disabled]="field.noEditable || (type === 'edit' && !canAdmin)">
        <i class="lf-icon-up-file common-icon__md"></i>
      </button>
    </div>
    @if (logo !== '') {
      <div class="field-type-logo__file-container"
        [ngClass]="{'field-type-logo__file-container--favicon': type === 'favicon'}">
        <img class="field-type-logo__logo-container"
          alt="Logo del cliente"
          [src]="logo">
      </div>
      <div class="field-type-logo__footer-container">
        <div class="field-type-logo__name-container"
          [attr.disabled]="field.noEditable || (type === 'edit' && !canAdmin)?true:null">
          <span>{{logoName}}</span>
          <button class="field-type-logo__clean-filter"
            (click)="cleanLogo()">
            <i class="lf-icon-close-thick common-icon__sm"></i>
          </button>
        </div>
        @if (type !== 'favicon') {
          <button class="common-button__link"
            [ngClass]="{'common-button__link--disabled': field.noEditable || (type === 'edit' && !canAdmin)}"
            (click)="openLogoModal()">
            <span class="common-button__link-text"
              [afTranslate]="'configure-image.adjust-size'">
              _Ajustar tamaños
            </span>
          </button>
        }
      </div>
    }
    <input
      [id]="'input-field-type-logo-' + fieldTypeLogo.id"
      class="hidden"
      type="file"
      accept="image/*"
      (change)="uploadLogo($event)"
      [disabled]="field.noEditable || (type === 'edit' && !canAdmin)"/>
  </div>
  @if (field.error){
    <div class="common-text-input__mandatory-tag">
      @if (field.blocker){
        <i class="lf-icon-warning common-icon__error-md"></i>
      }
      @if (field.errorText) {
        <span>{{field.errorText}}</span>
      }@else {
        <span [afTranslate]="field.blocker ? 'common.field-mandatory-blocking' : 'common.field-mandatory'">Campo obligatorio</span>
      }
    </div>
  }
</div>
